import { Flex, Text } from "@mantine/core";
import { BsCheckCircle } from "react-icons/bs";
import { CloseCircle, InfoCircle } from "iconsax-react";

interface PasswordRequirementItemProps {
  satisfied: boolean;
  hasPasswordOne: boolean;
  text: string;
}

const PasswordRequirementItem = ({
  satisfied,
  hasPasswordOne,
  text,
}: PasswordRequirementItemProps) => {
  return (
    <Flex direction="row" align="center" gap={6}>
      {hasPasswordOne ? (
        satisfied ? (
          <BsCheckCircle size="20" color="green" />
        ) : (
          <CloseCircle size="20" color="#DF0000" />
        )
      ) : (
        <InfoCircle size="20" color="#868686" />
      )}
      <Text color="#161616">{text}</Text>
    </Flex>
  );
};

export default PasswordRequirementItem;
